import React, { ReactElement } from 'react';

const EmailUsIcon = (): ReactElement => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2983 16.6666V4.16663H0.964966V16.6666H19.2983ZM2.91756 5.83329L10.1316 11.4442L17.3457 5.83329H2.91756ZM17.6316 7.72234L10.1316 13.5557L2.63163 7.72234V15H17.6316V7.72234Z"
      fill="#404040"
    />
    <mask
      id="mask0_478_329"
      maskUnits="userSpaceOnUse"
      x="0"
      y="4"
      width="20"
      height="13"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2983 16.6666V4.16663H0.964966V16.6666H19.2983ZM2.91756 5.83329L10.1316 11.4442L17.3457 5.83329H2.91756ZM17.6316 7.72234L10.1316 13.5557L2.63163 7.72234V15H17.6316V7.72234Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_478_329)"></g>
  </svg>
);

export default EmailUsIcon;
